import { FormattedDate } from '@elotech/components';
import { ArquivoEntity } from 'common/type';
import React from 'react';

type Props = {
  file: ArquivoEntity;
  onRemoveFile(file: any): void;
  canDelete?: boolean;
  sizeDivFile?: number;
  onDownload(file: any): void;
  onView(file: any): void;
};

const DragDropItem: React.FunctionComponent<Props> = ({
  file,
  canDelete,
  sizeDivFile,
  onRemoveFile,
  onDownload,
  onView
}) => {
  const getUsuario = usuario => {
    return usuario ? <span> - Usuário: {usuario}</span> : '';
  };

  const getData = data => {
    return data ? (
      <>
        <span> - Data: </span>
        <FormattedDate value={data} />
      </>
    ) : (
      ''
    );
  };

  return (
    <li className={`col-md-${sizeDivFile}`}>
      <div className="dragdrop-item">
        <div className="name">
          <span>{file.arquivo.nome}</span>
          {getUsuario(file.arquivo.usuarioResponsavel)}
          {getData(file.arquivo.dataCriacao)}
        </div>
        <div className="buttons">
          <button
            type="button"
            className="btn circle"
            onClick={() => onView(file)}
          >
            <i className="fa fa-eye" />
            <div className="btn-actions-label">Visualizar</div>
          </button>
          <button type="button" className="btn circle" onClick={onDownload}>
            <i className="fa fa-download" />
            <div className="btn-actions-label">Download</div>
          </button>
          {canDelete && (
            <button
              type="button"
              className="btn circle"
              onClick={onRemoveFile}
              id="btn-remove"
            >
              <i className="fa fa-trash" />
              <div className="btn-actions-label">Excluir</div>
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

export default DragDropItem;
